import { render, staticRenderFns } from "./PaymentPage.vue?vue&type=template&id=b97fa622&scoped=true&"
import script from "./PaymentPage.vue?vue&type=script&lang=js&"
export * from "./PaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPage.vue?vue&type=style&index=0&id=b97fa622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97fa622",
  null
  
)

export default component.exports